import { IconNames } from '../../common/components/Icon/IconNames';
import { registryData } from '../config/registryData';

/**
 * Get registry icon by type
 * @param {string} type - Registry type
 * @return {IconNames} Icon name
 */
export const getRegistryIcon = (type: string): IconNames => {
  const registry = registryData.find(item => item.type === type);
  return registry?.iconName || 'registryCZUK';
};

/**
 * Get registry title by type
 * @param {string} type - Registry type
 * @return {string} Registry title
 */
export const getRegistryTitle = (type: string): string => {
  const registry = registryData.find(item => item.type === type);
  return registry?.title || "Neznámý rejstřík";
};
